import { render, staticRenderFns } from "./ProfileDetail.vue?vue&type=template&id=06e8cc9a&"
import script from "./ProfileDetail.vue?vue&type=script&lang=js&"
export * from "./ProfileDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports